// extracted by mini-css-extract-plugin
module.exports = {"container":"TextChipPriceBar_container__NMqDD","left":"TextChipPriceBar_left__3Jcm_","right":"TextChipPriceBar_right__BOC1n"};